import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { formatToCommaWithLang, t, toCommaOptions, useChipSetStore, useVoucherStore } from '@slot-nx/core'
import { useGameStore } from '../domain/game/store/GameStore'
import { useGodziDropStore } from '../domain/godziDrop/store/godziDropStore'
import { GodziType } from '../domain/godziDrop/enum/godziDropEnum'
// import { useGodziDropStore } from '../domain/godziDrop/store/godziDropStore';
interface StakeContainerProps {
  x: number
  y: number
}

export const StakeContainer = (props: StakeContainerProps) => {
  const startX = props.x
  const startY = props.y
  const currentStake = useChipSetStore(x => x.computed.currentStake)
  const fixedStake = useVoucherStore(x => x.fixedStake)
  const isAnteBet = useGameStore(x => x.isAnteBet)
  const isVoucherTime = useGameStore(x => x.isVoucherTime)
  const { isGodziTime, godziResult } = useGodziDropStore()
  const stake = isAnteBet
    && !(isGodziTime && (godziResult.type === GodziType.FreeGame || godziResult.type === GodziType.FreeSpin))
    ? formatToCommaWithLang(currentStake * 1.25, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
    : formatToCommaWithLang(currentStake, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
  const displayStake = isVoucherTime ? formatToCommaWithLang(fixedStake) : stake

  return (
    <Container x={startX} y={startY} name="stake container">
      <Text
        text={t('main_control_stake')}
        anchor={0.5}
        style={
          new TextStyle({
            fontSize: 38,
            fill: '#FFC0D8',
            align: 'center',
            stroke: '#FFC0D8',
            strokeThickness: 2,
            letterSpacing: 2,
            // dropShadow: true,
            // dropShadowColor: '#0c0c0c',
            // dropShadowBlur: 6,
            // dropShadowAngle: 1,
            // dropShadowDistance: 3,
          })
        }
      />
      <Text
        text={displayStake}
        anchor={0.5}
        y={50}
        style={
          new TextStyle({
            fontSize: 38,
            fill: 'white',
          })
        }
      />
    </Container>
  )
}
